import React from 'react';
import PropTypes from 'prop-types';

import { IsGranted } from '../IsGranted';
import { NoAccess } from '../NoAccess';

export const Feature = ({ component: Tag, children, ...rest }) => {
    return (
        <IsGranted center componentNoAccess={NoAccess} {...rest}>
            {children || (Tag && <Tag />)}
        </IsGranted>
    );
};

Feature.propTypes = {
    ...IsGranted.propTypes,
    rule: PropTypes.string.isRequired,
    component: PropTypes.elementType,
    reason: PropTypes.object,
    children: PropTypes.any,
};
